import { model } from "core/util";
import { PensionDpsSavingsStrategy as PensionDpsSavingsStrategyType, PensionDpsStrategyDto } from "types";

export const PensionDpsSavingsStrategy = model.createModel<PensionDpsStrategyDto, PensionDpsSavingsStrategyType>((json) => ({
    savingStrategyCode: json.SavingStrategyCode,
    savingStrategyName: json.SavingStrategyName,
    savingStrategyPortfolioInvestmentFunds: json.SavingStrategyPortfolioInvestmentFunds,
}));
